import React from 'react';
import styles from './Footer.module.css';

interface FooterLink {
  label: string;
  href:  string;
}

const LINKS: FooterLink[] = [
  { label: 'LinkedIn',     href: 'https://www.linkedin.com/in/tharanga-mahavila-7b9994199' },
  { label: 'GitHub',       href: 'https://github.com/TharangaMahavila' },
  { label: 'Email',        href: 'mailto:tharangamahavila@gmail.com' },
  { label: 'AWS Certified', href: 'https://www.credly.com/badges/2d4328fb-fd42-43cc-8ed7-49cace463770/public_url' },
];

export default function Footer(): React.ReactElement {
  return (
    <footer className={styles.footer}>
      <p className={styles.copy}>
        © {new Date().getFullYear()} Tharanga Mahavila
      </p>
      <ul className={styles.links} role="list">
        {LINKS.map(({ label, href }) => (
          <li key={label}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </footer>
  );
}
